import { createSelector } from 'reselect';

const Authentication = 'authentication';

const selectDFIMToken = (state) => state.get(Authentication).get('token');
const isAuthenticated = createSelector(selectDFIMToken, (data) => data !== null);

const selectUser = (state) => state.get(Authentication).get('user');
const getUser = createSelector(selectUser, (data) => data);

const selectUserRoles = (state) => state.get(Authentication).get('userRoles');
const getUserRoles = createSelector(selectUserRoles, (data) => data);

const selectIsLoading = (state) => state.get(Authentication).get('isLoading');
const getLoadingStatus = createSelector(selectIsLoading, (data) => data);

const selectActionResponse = (state) => state.get(Authentication).get('actionResponse');
const getAuthenticationActionResponse = createSelector(selectActionResponse, (data) => data);

export {
  isAuthenticated,
  getUserRoles,
  getUser,
  getAuthenticationActionResponse,
  getLoadingStatus,
};
